var chunkMapping = {
	"99": [
		23253
	],
	"287": [
		80385
	],
	"1283": [
		72676
	],
	"1868": [
		73523
	],
	"2323": [
		23866
	],
	"2894": [
		96689
	],
	"2938": [
		32279
	],
	"4283": [
		18810,
		55156
	],
	"4786": [
		81829
	],
	"5184": [
		53942
	],
	"5241": [
		38207
	],
	"5566": [
		67295
	],
	"5849": [
		55372
	],
	"6158": [
		75789
	],
	"6372": [
		95498
	],
	"6836": [
		81707
	],
	"7083": [
		20012
	],
	"7619": [
		22172
	],
	"7669": [
		49648
	],
	"7964": [
		92139
	],
	"8531": [
		84805
	],
	"8912": [
		45899
	],
	"9917": [
		79917
	]
};
var idToExternalAndNameMapping = {
	"18810": [
		"default",
		"./atoms",
		39968
	],
	"20012": [
		"default",
		"./zones",
		77184
	],
	"22172": [
		"default",
		"./payments",
		68057
	],
	"23253": [
		"default",
		"./sign-in",
		28932
	],
	"23866": [
		"default",
		"./payments",
		77184
	],
	"32279": [
		"default",
		"./single-menu",
		68057
	],
	"38207": [
		"default",
		"./sign-up",
		28932
	],
	"45899": [
		"default",
		"./ads",
		77184
	],
	"49648": [
		"default",
		"./packages",
		77184
	],
	"53942": [
		"default",
		"./thank-you",
		28932
	],
	"55156": [
		"default",
		"./colors",
		39968
	],
	"55372": [
		"default",
		"./profile",
		68057
	],
	"67295": [
		"default",
		"./ads_discount",
		77184
	],
	"72676": [
		"default",
		"./menu",
		68057
	],
	"73523": [
		"default",
		"./icons",
		77184
	],
	"75789": [
		"default",
		"./allergies",
		77184
	],
	"79917": [
		"default",
		"./main-client",
		39968
	],
	"80385": [
		"default",
		"./forgot-password",
		28932
	],
	"81707": [
		"default",
		"./restaurant-categories",
		77184
	],
	"81829": [
		"default",
		"./restaurants",
		77184
	],
	"84805": [
		"default",
		"./reset-password",
		28932
	],
	"92139": [
		"default",
		"./advertisements",
		68057
	],
	"95498": [
		"default",
		"./email-confirmation",
		28932
	],
	"96689": [
		"default",
		"./users",
		77184
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}